module.exports = __webpack_public_path__ + "c_static/img/短信界面.df64622.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/短信界面.png
// module id = zQa9
// module chunks = 33